// Replenishment — "Gerar agora": pedidos de execução a pedido de ETLs (API interna, sessão).
import axios from 'axios';

export type EtlJobName = 'catalog_classification' | 'promo_store';
export type EtlJobStatus = 'queued' | 'running' | 'success' | 'error';

export interface EtlJobRequest {
  id: number;
  job: EtlJobName;
  status: EtlJobStatus;
  requested_at: string;
  started_at: string | null;
  finished_at: string | null;
  message: string;
  requested_by: string | null;
}

export interface EtlJobState {
  job: EtlJobName;
  enabled: boolean;
  request: EtlJobRequest | null;
}

const client = axios.create({
  baseURL: '/api/replenishment/jobs',
  timeout: 15000,
  withCredentials: true,
  // Django: cookie csrftoken + header X-CSRFToken (SessionAuthentication)
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname !== '/login') {
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

export const etlJobsApi = {
  latest: async (job: EtlJobName): Promise<EtlJobState> => (await client.get('/', { params: { job } })).data,
  request: async (job: EtlJobName): Promise<EtlJobRequest> => (await client.post('/', { job })).data,
};
